import type { IconSvgObject } from './types';

/** @deprecated Renamed to `ClockHour6Icon`; this file will be removed in the next major version. */
const ClockHourSixIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 6V11.7143V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ClockHourSixIcon;
